import React from "react";
import "./index.scss";
import tutorialImg from "assets/images/tutorialImg2.jpg";

const TutorialVideoPanel = () => (
  <section className="tutorial-panel">
    <div
      className="panel-body"
      onClick={() =>
        window.open(
          "https://www.youtube.com/channel/UCnGBghXDc1iHGbAfT6p4b0A",
          "_blank"
        )
      }
      aria-hidden
    >
      <img src={tutorialImg} alt="tutorial" />
      <div className="header">
        <p className="label">Need an in-depth guide?</p>
        <p className="sublabel">Watch our tutorial here.</p>
      </div>
    </div>
    <div />
  </section>
);

export default TutorialVideoPanel;
